import classNames from 'classnames';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.css';

export default class Button extends Component {
    static propTypes = {
        theme: PropTypes.oneOf(['yellow', 'red', 'gray', 'white', 'black']).isRequired,
        disabled: PropTypes.bool,
        onClick: PropTypes.func,
        link: PropTypes.string,
        type: PropTypes.string,
        className: PropTypes.string,
        noPadding: PropTypes.bool,
        fullWidth: PropTypes.bool,
    };

    render() {
        if (this.props.link) {
            return (
                <Link
                    className={classNames(styles.root, this.props.className, styles[this.props.theme], {
                        [styles.disabled]: this.props.disabled,
                        [styles.wFull]: this.props.fullWidth,
                    })}
                    to={this.props.link}
                    disabled={this.props.disabled}
                    onClick={this.props.onClick}>
                    {this.props.children}
                </Link>
            );
        }
        return (
            <button
                type={this.props.type}
                className={classNames(styles.root, this.props.className, styles[this.props.theme], {
                    [styles.disabled]: this.props.disabled,
                    [styles.noPadding]: this.props.noPadding,
                    [styles.wFull]: this.props.fullWidth,
                })}
                disabled={this.props.disabled}
                onClick={this.props.onClick}>
                {this.props.children}
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./components/button/index.js